/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ValidateTokenResponse } from './ValidateTokenResponse';
import {
    ValidateTokenResponseFromJSON,
    ValidateTokenResponseFromJSONTyped,
    ValidateTokenResponseToJSON,
} from './ValidateTokenResponse';

/**
 * 
 * @export
 * @interface PostTokenValidate200ResponseAllOf
 */
export interface PostTokenValidate200ResponseAllOf {
    /**
     * 
     * @type {ValidateTokenResponse}
     * @memberof PostTokenValidate200ResponseAllOf
     */
    result?: ValidateTokenResponse;
}

/**
 * Check if a given object implements the PostTokenValidate200ResponseAllOf interface.
 */
export function instanceOfPostTokenValidate200ResponseAllOf(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostTokenValidate200ResponseAllOfFromJSON(json: any): PostTokenValidate200ResponseAllOf {
    return PostTokenValidate200ResponseAllOfFromJSONTyped(json, false);
}

export function PostTokenValidate200ResponseAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostTokenValidate200ResponseAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'result': !exists(json, 'result') ? undefined : ValidateTokenResponseFromJSON(json['result']),
    };
}

export function PostTokenValidate200ResponseAllOfToJSON(value?: PostTokenValidate200ResponseAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'result': ValidateTokenResponseToJSON(value.result),
    };
}

